// extracted by mini-css-extract-plugin
export default {"link":"Link_link__BMbCr","text":"Link_text__yHAa4"};